import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';

import { initDone as initDoneSelector } from 'ggApp/modules/init/selectors';
import { isLoggedIn as isLoggedInSelector } from 'ggApp/modules/auth/selectors';
import { getFavoritesProducts as getFavoritesProductsAction } from 'ggApp/modules/favorites/actions';
import { favoriteList as favoriteListSelector } from 'ggApp/modules/favorites/selectors';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';

import { ForYou } from './ForYou';
import { location as locationSelector } from '../../../modules/router/selectors';
import { showCountdownTimer as showCountdownTimerSelector } from '../../../modules/featureFlag';

const enhance = compose(
    connect(
        createStructuredSelector({
            activeStore: activeStoreSelector,
            favoriteList: favoriteListSelector,
            initDone: initDoneSelector,
            isUserLoggedIn: isLoggedInSelector,
            location: locationSelector,
            showCountdownTimer: showCountdownTimerSelector,
        }),
        (dispatch) => ({
            getFavoritesProducts: bindActionCreators(getFavoritesProductsAction, dispatch),
        }),
    ),
    withProps(({ categoriesWidgetOnHomepageEnabled }) => ({
        categoriesWidgetOnHomepageEnabled: categoriesWidgetOnHomepageEnabled ?? false,
    })),
);

export default enhance(ForYou);
